import classNames from "classnames";
import { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { useModalControl } from "../../customHooks/useModalControl";
import { useWindowDimensions } from "../../customHooks/useWindowDimensions";
import { isProfileApproved } from "../../helperFunctions";
import { useFetchInvitationsQuery } from "../../redux/features/cooperative/cooperative.api";
import { useFetchGuarantorLoanRequestsQuery } from "../../redux/features/loans/loans.api";
import { useAppSelector } from "../../redux/hooks";
import { Icon } from "../icons/icon";
import { PopoverMenu } from "../inputs/popover";
import { AppNotificationsModal } from "../modals/app_modals/notificationsModal";
import { ProfilePicture } from "../profile/profilePicture";
import { Notifications } from "./notifications";

const NotificationBell = ({
  className = "",
  onClick = () => {},
}: {
  className?: string;
  onClick?: () => void;
}) => {
  const [notificationCount, setNotificationCount] = useState<number>(0);

  const profile = useAppSelector((state) => {
    return state.auth.profile;
  });

  const { data: guarantorRequests } = useFetchGuarantorLoanRequestsQuery(
    { detail: true },
    {
      pollingInterval: 300000,
      skip: profile?.type !== "member",
      refetchOnMountOrArgChange: true,
    }
  );

  const { data: invitations } = useFetchInvitationsQuery(undefined, {
    pollingInterval: 300000,
    skip: profile?.type !== "member",
    refetchOnMountOrArgChange: true,
  });

  useEffect(() => {
    setNotificationCount(
      (guarantorRequests?.data?.length ?? 0) + (invitations?.data?.length ?? 0)
    );
  }, [guarantorRequests, invitations]);

  return (
    <button
      className={classNames(
        "relative border border-light-grey w-fit p-[6px] rounded-full",
        className
      )}
      type="button"
      onClick={() => {
        onClick();
      }}
    >
      <Icon svg={"sms"} width={20} height={20} />

      <p
        className={`
            absolute top-0 -right-1 flex items-center justify-center
            min-w-[16px] h-[16px] bg-red-200
            text-white text-xs font-medium text-center
            rounded-full ${notificationCount === 0 && "!hidden"}
            `}
      >
        {notificationCount}
      </p>
    </button>
  );
};

export const ProfileNotificationComponent = () => {
  const { profile } = useAppSelector((state) => state.auth);

  const { width } = useWindowDimensions();

  const { modal, modalOpen, handleModalClose, handleModalOpen } =
    useModalControl();

  return (
    <>
      <div className="flex items-center gap-3">
        {/* Notification and profile */}
        <PopoverMenu
          customMenuItems={({ close }) => {
            return (
              <Notifications
                close={() => {
                  close();
                }}
              />
            );
          }}
          position={width >= 1024 ? "bottom start" : "bottom end"}
          menuClassName="
          !z-[999]
          flex flex-col !max-w-[480px]
          bg-white !w-full !min-w-fit
          h-full !max-h-[424px] shadow-lg
          border border-pry-dark-green-300/10
          rounded-[16px] !overflow-x-hidden mr-4
          "
          className="hidden md:block"
        >
          <NotificationBell />
        </PopoverMenu>

        <NotificationBell
          className="md:hidden"
          onClick={() => {
            handleModalOpen("notificationsModal");
          }}
        />

        <NavLink
          to="/app/settings"
          onClick={(e) => {
            if (!isProfileApproved(profile)) {
              e.preventDefault();
            }
          }}
        >
          <ProfilePicture />
        </NavLink>
      </div>

      {width < 768 ? (
        <AppNotificationsModal
          isModalOpen={modalOpen && modal === "notificationsModal"}
          onModalClose={() => {
            handleModalClose();
          }}
        />
      ) : undefined}
    </>
  );
};
